import { useState, useEffect } from 'react';

const FAVORITES_KEY = 'vergo_favorites';

export const useFavorites = () => {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    const saved = localStorage.getItem(FAVORITES_KEY);
    if (saved) {
      try {
        setFavorites(JSON.parse(saved));
      } catch (error) {
        console.error('Error loading favorites:', error);
        localStorage.removeItem(FAVORITES_KEY);
      }
    }
  }, []);

  const toggleFavorite = (botId: string) => {
    setFavorites(prev => {
      const newFavorites = prev.includes(botId)
        ? prev.filter(id => id !== botId)
        : [...prev, botId];
      
      localStorage.setItem(FAVORITES_KEY, JSON.stringify(newFavorites));
      return newFavorites;
    });
  };

  const isFavorite = (botId: string) => favorites.includes(botId);

  const clearFavorites = () => {
    setFavorites([]);
    localStorage.removeItem(FAVORITES_KEY);
  };

  return {
    favorites,
    toggleFavorite,
    isFavorite,
    clearFavorites
  };
};